import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
interface CountdownTimerProps {
  className?: string;
}
export function CountdownTimer({
  className = ''
}: CountdownTimerProps) {
  const {
    formattedTime
  } = useCountdown();
  return <span className={`font-mono font-bold tracking-wider ${className}`} data-id="element-34">
      {formattedTime}
    </span>;
}